import { useState, useEffect, useRef, useCallback } from 'react'

interface UseResizableOptions {
  onResize?: (height: number) => void
}

const useResizable = (isActive: boolean, options?: UseResizableOptions) => {
  const [height, setHeight] = useState<number | undefined>(0)
  const contentRef = useRef<HTMLDivElement | null>(null)
  const resizeObserverRef = useRef<ResizeObserver | null>(null)

  const updateHeight = useCallback(() => {
    if (contentRef.current) {
      const newHeight = contentRef.current.scrollHeight
      setHeight(newHeight)
      options?.onResize?.(newHeight)
    }
  }, [options])

  useEffect(() => {
    if (contentRef.current && isActive) {
      updateHeight()

      resizeObserverRef.current = new ResizeObserver(() => {
        updateHeight()
      })
      resizeObserverRef.current.observe(contentRef.current)
    }

    return () => {
      resizeObserverRef?.current?.disconnect()
    }
  }, [isActive, updateHeight])

  return { contentRef, height }
}

export default useResizable
